<div
  class="snackbar__container"
  [class.snackbar__container--error]="data.type === 'error'"
  [class.snackbar__container--valid]="data.type === 'valid'"
>
  <p class="snackbar__title">
    {{ data.title }}
    <mat-icon *ngIf="data.type === 'error'" class="snackbar__title__icon" svgIcon="cross"></mat-icon>
    <mat-icon *ngIf="data.type === 'valid'" class="snackbar__title__icon" svgIcon="valid"></mat-icon>
  </p>
  <p *ngIf="!!data.content" class="snackbar__content">
    {{ data.content }}
  </p>
</div>
